import { render, staticRenderFns } from "./AssociationsForm.vue?vue&type=template&id=6ae19653&scoped=true&lang=pug&"
import script from "./AssociationsForm.vue?vue&type=script&lang=js&"
export * from "./AssociationsForm.vue?vue&type=script&lang=js&"
import style0 from "./AssociationsForm.vue?vue&type=style&index=0&id=6ae19653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae19653",
  null
  
)

export default component.exports